const routes = [{
    path: '/',
    redirect: '/homePage',
    component: () => import( /* webpackChunkName: "homePage" */ "@/views/layouts/BasicLayout"),
    meta: { name: "首页", isMenu: false, code: 'materialCenter' },
    children: [
        {
            path: '/sales',
            redirect: "/sales/price/developDepartFill",
            component: () => import( /* webpackChunkName: "sales" */ "@/views/sales"),//销售
            meta: { isActive: 0, name: "收入预算", isMenu: true, icon: 'img/ico_shouru.png', activeIcon: 'img/ico_shouru_s.png', code: "budget:cale" },
            children: [
                {
                    path: '/sales/price',
                    redirect: "/sales/price/developDepartFill",
                    component: () => import( /* webpackChunkName: "price" */ "@/views/sales/price"),
                    meta: { name: "价格", isMenu: true, icon: 'icon-cttq-jiage', code: "budget:cale:price" },
                    children: [
                        {
                            path: '/sales/price/developDepartFill',
                            component: () => import( /* webpackChunkName: "developDepartFill" */ "@/views/sales/price/developDepart/fill.vue"),
                            meta: { name: "中标价预算填报", isMenu: false, code: 'budget:cale:price:winprice',eventId:"budget_zbj_fb_button"}
                        },
                        {
                            path: '/sales/price/developDepartCheck',
                            component: () => import( /* webpackChunkName: "developDepartCheck" */ "@/views/sales/price/developDepart/check.vue"),
                            meta: { name: "中标价预算查看", isMenu: false, code: 'budget:cale:price:winprice',eventId:"budget_zbj_ch_button"}
                        },
                    ]
                },
                {
                    path: '/sales/income',
                    redirect: "/sales/income/channelFill",
                    component: () => import( /* webpackChunkName: "income" */ "@/views/sales/income"),
                    meta: { name: "收入", isMenu: true, icon: 'icon-cttq-shouru', code: "budget:cale:incom" },
                    children: [
                        {
                            path: '/sales/income/channelFill',
                            component: () => import( /* webpackChunkName: "channelFill" */ "@/views/sales/income/channel/fill.vue"),
                            meta: { name: "销售渠道收入填报", isMenu: false, code: 'budget:cale:incom:channelincome' }
                        },
                        {
                            path: '/sales/income/channelCheck',
                            component: () => import( /* webpackChunkName: "channelCheck" */ "@/views/sales/income/channel/check.vue"),
                            meta: { name: "销售渠道收入查看", isMenu: false, code: 'budget:cale:incom:channelincome' },
                        },
                        {
                            path: '/sales/income/pureSaleIncomeFill',
                            component: () => import( /* webpackChunkName: "pureSaleIncomeFill" */ "@/views/sales/income/pureSaleIncome/fill.vue"),
                            meta: { name: "销售纯销收入填报", isMenu: false, code: 'budget:cale:incom:puresellincome' },
                        },
                        {
                            path: '/sales/income/pureSaleIncomeCheck',
                            component: () => import( /* webpackChunkName: "pureSaleIncomeCheck" */ "@/views/sales/income/pureSaleIncome/check.vue"),
                            meta: { name: "销售纯销收入查看", isMenu: false, code: 'budget:cale:incom:puresellincome' },
                        },
                        {
                            path: '/sales/income/basicFill',
                            component: () => import( /* webpackChunkName: "basicFill" */ "@/views/sales/income/basic/fill.vue"),
                            meta: { name: "销售基层收入填报", isMenu: false, code: 'budget:cale:incom:grassincome' }
                        },
                        {
                            path: '/sales/income/basicCheck',
                            component: () => import( /* webpackChunkName: "basicCheck" */ "@/views/sales/income/basic/check.vue"),
                            meta: { name: "销售基层收入查看", isMenu: false, code: 'budget:cale:incom:grassincome' },
                        },
                        {
                            path: '/sales/income/marketIncomeFill',
                            component: () => import( /* webpackChunkName: "marketIncomeFill" */ "@/views/sales/income/marketIncome/fill.vue"),
                            meta: { name: "销售市场部收入填报", isMenu: false, code: 'budget:cale:incom:marketincome' },
                        },
                        {
                            path: '/sales/income/marketIncomeCheck',
                            component: () => import( /* webpackChunkName: "marketIncomeCheck" */ "@/views/sales/income/marketIncome/check.vue"),
                            meta: { name: "销售市场部收入查看", isMenu: false, code: 'budget:cale:incom:marketincome' },
                        },
                        {
                            path: '/sales/income/strategyFill',
                            component: () => import( /* webpackChunkName: "strategyFill" */ "@/views/sales/income/strategy/fill.vue"),
                            meta: { name: "销售战略指标收入填报", isMenu: false, code: 'budget:cale:incom:challenge' }
                        },
                        {
                            path: '/sales/income/strategyCheck',
                            component: () => import( /* webpackChunkName: "strategyCheck" */ "@/views/sales/income/strategy/check.vue"),
                            meta: { name: "销售战略指标收入查看", isMenu: false, code: 'budget:cale:incom:challenge' },
                        },
                        {
                            path: '/sales/income/rawSaleFill',
                            component: () => import( /* webpackChunkName: "rawSaleFill" */ "@/views/sales/income/rawSale/fill.vue"),
                            meta: { name: "销售原药料销售填报", isMenu: false, code: 'budget:cale:incom:apisale',eventId:"budget_yclxs_fb_button" },
                        },
                        {
                            path: '/sales/income/rawSaleCheck',
                            component: () => import( /* webpackChunkName: "rawSaleCheck" */ "@/views/sales/income/rawSale/check.vue"),
                            meta: { name: "销售原药料销售查看", isMenu: false, code: 'budget:cale:incom:apisale',eventId:"budget_yclxs_ch_button"},
                        },
						{
							path: '/sales/deliver/deliverCheck',
                            component: () => import( /* webpackChunkName: "secBarginAreaCheck" */ "@/views/sales/deliver/deliverCheck.vue"),
							meta: { name: "销售-发货政策", isMenu: false, code: 'budget:cale:fahuo:budget'},
						},
                        {
                            path: '/sales/income/rawExportFill',
                            component: () => import( /* webpackChunkName: "rawExportFill" */ "@/views/sales/income/rawExport/fill.vue"),
                            meta: { name: "出口业务预算填报", isMenu: false, code: 'budget:cale:incom:apisalesout' },
                        },
                        {
                            path: '/sales/income/rawExportCheck',
                            component: () => import( /* webpackChunkName: "rawExportCheck" */ "@/views/sales/income/rawExport/check.vue"),
                            meta: { name: "出口业务预算查看", isMenu: false, code: 'budget:cale:incom:apisalesout' },
                        }
					]
				},
                {
					path: '/sales/collect',
					redirect: "/sales/collect/ziyingFill",
                    component: () => import( /* webpackChunkName: "secondbargaining" */ "@/views/sales/collect"),
					meta: { name: "新品收集", isMenu: true, icon: 'icon-cttq-erciyijia', code: "budget:cale:new"},
					children: [
                        {
							path: '/sales/collect/ziyingFill',
                            component: () => import( /* webpackChunkName: "ziyingFill" */ "@/views/sales/collect/collectProduct.vue"),
							meta: { name: "自营新产品收集填报", isMenu: false, code: 'budget:cale:new:budget:ziying',businessModel:'1',eventId:"budget_xpsj_zy_fb_button"},
                        },
						{
							path: '/sales/collect/ziyingCheck',
                            component: () => import( /* webpackChunkName: "ziyingCheck" */ "@/views/sales/collect/searchProduct.vue"),
							meta: { name: "自营新产品收集查看", isMenu: false, code: 'budget:cale:new:budget:ziying',businessModel:'1',eventId:"budget_xpsj_zy_ch_button"},
                        },
                        {
							path: '/sales/collect/tuiguangFill',
                            component: () => import( /* webpackChunkName: "tuiguangFill" */ "@/views/sales/collect/collectProduct.vue"),
							meta: { name: "代理推广新产品收集填报", isMenu: false, code: 'budget:cale:new:budget:tuiguang',businessModel:'2',eventId:"budget_xpsj_tg_fb_button"},
                        },
						{
							path: '/sales/collect/tuiguangCheck',
                            component: () => import( /* webpackChunkName: "tuiguangCheck" */ "@/views/sales/collect/searchProduct.vue"),
							meta: { name: "代理推广新产品收集查看", isMenu: false, code: 'budget:cale:new:budget:tuiguang',businessModel:'2',eventId:"budget_xpsj_tg_ch_button"},
                        },
                        {
							path: '/sales/collect/fahuoFill',
                            component: () => import( /* webpackChunkName: "fahuoFill" */ "@/views/sales/collect/collectProduct.vue"),
							meta: { name: "代理发货新产品收集填报", isMenu: false, code: 'budget:cale:new:budget:fahuo',businessModel:'3',eventId:"budget_xpsj_fh_fb_button"},
                        },
						{
							path: '/sales/collect/fahuoCheck',
                            component: () => import( /* webpackChunkName: "fahuoCheck" */ "@/views/sales/collect/searchProduct.vue"),
							meta: { name: "代理发货新产品收集查看", isMenu: false, code: 'budget:cale:new:budget:fahuo',businessModel:'3',eventId:"budget_xpsj_fh_ch_button"},
                        }
					]
				},
				{
					path: '/sales/secondbargaining',
					redirect: "/sales/secondbargaining/secBarginAreaFill",
                    component: () => import( /* webpackChunkName: "secondbargaining" */ "@/views/sales/secBargin"),
					meta: { name: "二次议价", isMenu: true, icon: 'icon-cttq-erciyijia', code: "budget:cale:secondbargaining"},
					children: [
						{
							path: '/sales/secondbargaining/secBarginAreaFill',
                            component: () => import( /* webpackChunkName: "secBarginAreaFill" */ "@/views/sales/secBargin/areaFill.vue"),
							meta: { name: "销售-纯销-二次议价", isMenu: false, code: 'budget:cale:secondbargaining:secondcost'},
                        }
                    ]
                },
                {
                    path: '/sales/deliver',
                    redirect: "/sales/deliver/deliverFill",
                    component: () => import( /* webpackChunkName: "secondbargaining" */ "@/views/sales/deliver"),
                    meta: { name: "发货政策", isMenu: true, icon: 'icon-cttq-erciyijia', code: "budget:cale:fahuo" },
                    children: [
                        {
                            path: '/sales/deliver/deliverFill',
                            component: () => import( /* webpackChunkName: "secBarginAreaFill" */ "@/views/sales/deliver/deliverFill.vue"),
                            meta: { name: "销售-发货政策", isMenu: false, code: 'budget:cale:fahuo:budget',eventId:"budget_fhzc_fb_button" },
                        },
                        {
                            path: '/sales/deliver/deliverCheck',
                            component: () => import( /* webpackChunkName: "secBarginAreaCheck" */ "@/views/sales/deliver/deliverCheck.vue"),
                            meta: { name: "销售-发货政策", isMenu: false, code: 'budget:cale:fahuo:budget',eventId:"budget_fhzc_ch_button" },
                        }
                    ]
                },
                {
                    path: '/sales/secondbargaining',
                    redirect: "/sales/secondbargaining/secBarginAreaFill",
                    component: () => import( /* webpackChunkName: "secondbargaining" */ "@/views/sales/secBargin"),
                    meta: { name: "二次议价", isMenu: true, icon: 'icon-cttq-erciyijia', code: "budget:cale:secondbargaining" },
                    children: [
                        {
                            path: '/sales/secondbargaining/secBarginAreaFill',
                            component: () => import( /* webpackChunkName: "secBarginAreaFill" */ "@/views/sales/secBargin/areaFill.vue"),
                            meta: { name: "销售-纯销-二次议价", isMenu: false, code: 'budget:cale:secondbargaining:secondcost' },
                        },
                        {
                            path: '/sales/secondbargaining/secBarginAreaCheck',
                            component: () => import( /* webpackChunkName: "secBarginAreaCheck" */ "@/views/sales/secBargin/areaCheck.vue"),
                            meta: { name: "销售-纯销-二次议价", isMenu: false, code: 'budget:cale:secondbargaining:secondcost' },
                        },
                    ]
                },
                {
                    path: '/sales/return',
                    redirect: "/sales/return/rebateFill",
                    component: () => import( /* webpackChunkName: "return" */ "@/views/sales/rebate"),
                    meta: { name: "返利", isMenu: true, icon: 'icon-cttq-fanli', code: "budget:cale:return" },
                    children: [
                        {
                            path: '/sales/return/rebateFill',
                            component: () => import( /* webpackChunkName: "rebateFill" */ "@/views/sales/rebate/fill.vue"),
                            meta: { name: "销售返利费用填报", isMenu: false, code: 'budget:cale:return:returncost' }
                        },
                        {
                            path: '/sales/return/rebateCheck',
                            component: () => import( /* webpackChunkName: "rebateCheck" */ "@/views/sales/rebate/check.vue"),
                            meta: { name: "销售返利费用查看", isMenu: false, code: 'budget:cale:return:returncost' },
                        },
                    ]
                }, {
                    path: '/sales/income/strategyFill',
                    redirect: "/sales/income/strategyFill",
                    component: () => import( /* webpackChunkName: "return" */ "@/views/sales/rebate"),
                    meta: { name: "挑战指标", isMenu: true, icon: 'icon-cttq-fanli', code: "budget:cale:challange" },
                    children: [
                        {
                            path: '/sales/income/strategyFill',
                            component: () => import( /* webpackChunkName: "strategyFill" */ "@/views/sales/income/strategy/fill.vue"),
                            meta: { name: "挑战指标填报", isMenu: false, code: 'budget:cale:challange:budget',eventId:"budget_tzzb_fb_button" }
                        },
                        {
                            path: '/sales/income/strategyCheck',
                            component: () => import( /* webpackChunkName: "strategyCheck" */ "@/views/sales/income/strategy/check.vue"),
                            meta: { name: "挑战指标查看", isMenu: false, code: 'budget:cale:challange:budget',eventId:"budget_tzzb_ch_button" },
                        },
                    ]
                }
            ]
        },
        {
            path: '/research',
            component: () => import( /* webpackChunkName: "research" */ "@/views/research"),//研发
            meta: { isActive: 0, name: "项目预算", isMenu: true, icon: 'img/ico_xiangmu.png', activeIcon: 'img/ico_xiangmu_s.png', code: 'budget:project' },///budget:research 为了做数据
            children: [{
                path: '/research/project',
                redirect: '/research/noProjectFill',
                component: () => import( /* webpackChunkName: "project" */ "@/views/research"),
                meta: { name: "项目", isMenu: true, icon: 'icon-cttq-xiangmu', activeIcon: 'img/ico_renshi_s.png', code: "budget:project:reserch" },
                children: [
                    {
                        path: '/research/noProjectFill',
                        component: () => import( /* webpackChunkName: "noProjectFill" */ "@/views/research/noProject/fill.vue"),
                        meta: { name: "未立项研发项目预算表填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: 'budget:project:reserch:nobudget',eventId:"budget_yfwlx_fb_button" }
                    }, {
                        path: '/research/noProjectCheck',
                        component: () => import( /* webpackChunkName: "noProjectCheck" */ "@/views/research/noProject/check.vue"),
                        meta: { name: "未立项研发项目预算表查看", isMenu: false, icon: 'icon-cttq-xiangmu', code: 'budget:project:reserch:nobudget',eventId:"budget_yfwlx_ch_button" }
                    }, {
                        path: '/research/setProjectFill',
                        component: () => import( /* webpackChunkName: "setProjectFill" */ "@/views/research/setProject/fill.vue"),
                        meta: { name: "已立项研发项目预算表填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: 'budget:project:reserch:yebudget',eventId:"budget_yfylx_fb_button" }
                    }, {
                        path: '/research/setProjectCheck',
                        component: () => import( /* webpackChunkName: "setProjectCheck" */ "@/views/research/setProject/check.vue"),
                        meta: { name: "已立项研发项目预算表查询", isMenu: false, icon: 'icon-cttq-xiangmu', code: 'budget:project:reserch:yebudget',eventId:"budget_yfylx_ch_button" }
                    }, {
                        path: '/research/setProjectDetail',
                        component: () => import( /* webpackChunkName: "setProjectDetail" */ "@/views/research/setProject/detail"),
                        meta: { name: "已立项研发项目预算表填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: 'budget:project:reserch:yebudget' }
                    },
                    {
                        path: '/research/setProjectDetailCheck',
                        component: () => import( /* webpackChunkName: "setProjectDetail" */ "@/views/research/setProject/detailCheck"),
                        meta: { name: "已立项研发项目预算表查看", isMenu: false, icon: 'icon-cttq-xiangmu', code: 'budget:project:reserch:yebudget'} // code需要看控制的返回
                    }
                ]
            },
            {
                path: '/marketProject/marketProjectFill',
                redirect: '/marketProject/marketProjectFill/fill',
                component: () => import( /* webpackChunkName: "infoFill" */ "@/views/marketProject"),
                meta: { name: "市场项目", isMenu: true, icon: 'icon-cttq-xiangmu', code: "budget:project:market" },
                children: [
                    {
                        path: '/marketProject/marketProjectFill/fill',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/marketProject/fill.vue"),
                        meta: { name: "市场项目填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:market:budget" }
                    }, {
                        path: '/marketProject/marketProjectCheck/check',
                        component: () => import( /* webpackChunkName: "infoCheck" */ "@/views/marketProject/check.vue"),
                        meta: { name: "市场项目查询", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:market:budget" }
                    },
                    {
                        path: '/marketProject/marketProjectFill/detail',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/marketProject/detail.vue"),
                        meta: { name: "市场项目填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:market:budget",eventId:"budget_scvxm_fb_button" }
                    },
                    {
                        path: '/marketProject/marketProjectCheck/detailCheck',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/marketProject/detailCheck.vue"),
                        meta: { name: "市场项目查看", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:market:budget",eventId:"budget_scxm_ch_button"}
                    }]
            },
            {
                path: '/medicalProject/medicalProjectFill',
                redirect: '/medicalProject/medicalProjectFill/fill',
                component: () => import( /* webpackChunkName: "infoFill" */ "@/views/medicalProject"),
                meta: { name: "医学研究项目", isMenu: true, icon: 'icon-cttq-xiangmu', code: "budget:project:madisen" },
                children: [
                    {
                        path: '/medicalProject/medicalProjectFill/fill',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/medicalProject/fill.vue"),
                        meta: { name: "医学研究项目填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:madisen:budget",eventId:"budget_yxyjxm_fb_button" }
                    }, {
                        path: '/medicalProject/medicalProjectCheck/check',
                        component: () => import( /* webpackChunkName: "infoCheck" */ "@/views/medicalProject/check.vue"),
                        meta: { name: "医学研究项目查询", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:madisen:budget",eventId:"budget_yxyjxm_ch_button" }
                    },
                    {
                        path: '/medicalProject/medicalProjectFill/detail',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/medicalProject/detail.vue"),
                        meta: { name: "医学研究项目填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:madisen:budget" }
                    },
                    {
                        path: '/medicalProject/medicalProjectCheck/detailCheck',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/medicalProject/detailCheck.vue"),
                        meta: { name: "医学研究项目查看", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:madisen:budget" }
                    }]
            },
            {
                path: '/otherProject/otherProjectFill',
                redirect: '/otherProject/otherProjectFill/fill',
                component: () => import( /* webpackChunkName: "infoFill" */ "@/views/otherProject"),
                meta: { name: "普通项目", isMenu: true, icon: 'icon-cttq-xiangmu', code: "budget:project:else" },
                children: [
                    {
                        path: '/otherProject/otherProjectFill/fill',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/otherProject/fill.vue"),
                        meta: { name: "普通项目填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:else:budget",eventId:"budget_qtxm_fb_button" }
                    }, {
                        path: '/otherProject/otherProjectCheck/check',
                        component: () => import( /* webpackChunkName: "infoCheck" */ "@/views/otherProject/check.vue"),
                        meta: { name: "普通项目查询", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:else:budget",eventId:"budget_qtjxm_ch_button" }
                    },
                    {
                        path: '/otherProject/otherProjectFill/detail',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/otherProject/detail.vue"),
                        meta: { name: "普通项目填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:else:budget" }
                    },
                    {
                        path: '/otherProject/otherProjectCheck/detailCheck',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/otherProject/detailCheck.vue"),
                        meta: { name: "普通项目查看", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:else:budget" }
                    }]
            },

            {
                path: '/info/infoFill',
                redirect: '/info/infoFill/fill',
                component: () => import( /* webpackChunkName: "infoFill" */ "@/views/info"),
                meta: { name: "信息项目", isMenu: true, icon: 'icon-cttq-xiangmu', code: "budget:project:inform" },
                children: [
                    {
                        path: '/info/infoFill/fill',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/info/fill.vue"),
                        meta: { name: "信息项目填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:inform:budget",eventId:"budget_xxxm_fb_button"  }
                    }, {
                        path: '/info/infoCheck/check',
                        component: () => import( /* webpackChunkName: "infoCheck" */ "@/views/info/check.vue"),
                        meta: { name: "信息项目发布后查询", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:inform:budget",eventId:"budget_xxxm_ch_button" }
                    }, {
                        path: '/info/infoCheck/projectFill',
                        component: () => import( /* webpackChunkName: "infoCheck" */ "@/views/info/projectFill.vue"),
                        meta: { name: "查看信息项目详情", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:inform:budget" }
                    }]
            },
            {
                path: '/engineering/costFill',
                redirect: '/engineering/engineeringFill/fill',
                component: () => import( /* webpackChunkName: "costFill" */ "@/views/cost"),
                meta: { name: "工程项目", isMenu: true, icon: 'icon-cttq-xiangmu', code: "budget:project:ingeer" },
                children: [
                    {
                        path: '/engineering/engineeringFill/fill',
                        component: () => import( /* webpackChunkName: "engineeringFill" */ "@/views/engineering/fill.vue"),
                        meta: { name: "工程项目填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:ingeer:budget",eventId:"budget_gcxm_fb_button"  }
                    }, {
                        path: '/engineering/engineeringCheck/check',
                        component: () => import( /* webpackChunkName: "engineeringCheck" */ "@/views/engineering/check.vue"),
                        meta: { name: "工程项目查询", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:ingeer:budget",eventId:"budget_gcxm_ch_button"  }
                    }, {
                        path: '/engineering/projectFillOfNew',
                        component: () => import( /* webpackChunkName: "projectFill" */ "@/views/engineering/projectFill.vue"),
                        meta: { name: "新建工程项目", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:ingeer:budget" }
                    }, {
                        path: '/engineering/projectFillOfEdit',
                        component: () => import( /* webpackChunkName: "projectFill" */ "@/views/engineering/projectFill.vue"),
                        meta: { name: "编辑工程项目", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:ingeer:budget" }
                    }, {
                        path: '/engineering/projectFillOfReadOnly',
                        component: () => import( /* webpackChunkName: "projectFill" */ "@/views/engineering/projectFill.vue"),
                        meta: { name: "查看工程项目", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:ingeer:budget" }
                    }]
            },
            {
                path: '/strategicProject/strategicProjectFill',
                redirect: '/strategicProject/strategicProjectFill/fill',
                component: () => import( /* webpackChunkName: "infoFill" */ "@/views/strategicProject"),
                meta: { name: "战略合作项目", isMenu: true, icon: 'icon-cttq-xiangmu', code: "budget:project:zhanlue" },
                children: [
                    {
                        path: '/strategicProject/strategicProjectFill/fill',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/strategicProject/fill.vue"),
                        meta: { name: "战略合作项目填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:zhanlue:budget",eventId:"budget_zlhzxm_fb_button" }
                    }, {
                        path: '/strategicProject/strategicProjectCheck/check',
                        component: () => import( /* webpackChunkName: "infoCheck" */ "@/views/strategicProject/check.vue"),
                        meta: { name: "战略合作项目查询", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:zhanlue:budget",eventId:"budget_zlhzxm_ch_button" }
                    },
                    {
                        path: '/strategicProject/strategicProjectFill/detail',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/strategicProject/detail.vue"),
                        meta: { name: "战略合作项目填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:zhanlue:budget" }
                    },
                    {
                        path: '/strategicProject/strategicProjectCheck/detailCheck',
                        component: () => import( /* webpackChunkName: "infoFill" */ "@/views/strategicProject/detailCheck.vue"),
                        meta: { name: "战略合作项目查看", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:project:zhanlue:budget" }
                    }]
            },
            {
                path: '/bdProject',
                redirect: '/bdProject/fill',
                component: () => import( /* webpackChunkName: "infoFill" */ "@/views/strategicProject"),
                meta: { name: "BD项目", isMenu: true, icon: 'icon-cttq-xiangmu', code: "budget:project:bd" }, 
                children:[
                    {
                        path: '/bdProject/fill',
                        component: () => import( /* webpackChunkName: "setProjectFill" */ "@/views/bdProject/fill.vue"),
                        meta: { name: "BD项目预算表填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: 'budget:project:bd:budget',eventId:"budget_bdxm_fb_button" }
                    }, {
                        path: '/bdProject/check',
                        component: () => import( /* webpackChunkName: "setProjectCheck" */ "@/views/bdProject/check.vue"),
                        meta: { name: "BD项目预算表查询", isMenu: false, icon: 'icon-cttq-xiangmu', code: 'budget:project:bd:budget',eventId:"budget_bdxm_ch_button" }
                    }, {
                        path: '/bdProject/detail',
                        component: () => import( /* webpackChunkName: "setProjectDetail" */ "@/views/bdProject/detail"),
                        meta: { name: "BD项目预算表填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: 'budget:project:bd:budget' }
                    },
                    {
                        path: '/bdProject/detailCheck',
                        component: () => import( /* webpackChunkName: "setProjectDetail" */ "@/views/bdProject/detailCheck"),
                        meta: { name: "BD项目预算表查看", isMenu: false, icon: 'icon-cttq-xiangmu', code: 'budget:project:bd:budget' }
                    }
                ]
            },
            {
                path: '/governmentGrant',
                redirect: '/governmentGrant/fill',
                component: () => import( /* webpackChunkName: "infoFill" */ "@/views/governmentGrant"),
                meta: { name: "政府拨款项目", isMenu: true, icon: 'icon-cttq-xiangmu', code: "budget:project:government" }, 
                children:[
                    {
                        path: '/governmentGrant/fill',
                        component: () => import( /* webpackChunkName: "marketIncomeFill" */ "@/views/governmentGrant/fill.vue"),
                        meta: { name: "政府拨款项目填报", isMenu: false, code: 'budget:project:government:budget',eventId:"budget_zfbkxm_fb_button" },
                    },
                    {
                        path: '/governmentGrant/check',
                        component: () => import( /* webpackChunkName: "marketIncomeCheck" */ "@/views/governmentGrant/check.vue"),
                        meta: { name: "政府拨款项目查看", isMenu: false, code: 'budget:project:government:budget',eventId:"budget_zfbkxm_fb_button" },
                    },
                ]
            },            
            ]
        },
        {
            path: '/production',
            component: () => import( /* webpackChunkName: "production" */ "@/views/production"),
            meta: { isActive: 0, name: "产能预算", isMenu: true, icon: 'img/ico_channeng.png', activeIcon: 'img/ico_channeng_s.png', code: "budget:product" },
            children: [
                {
                    path: '/production/productionFill',
                    redirect: '/production/productionFill/fill',
                    component: () => import( /* webpackChunkName: "productionFill" */ "@/views/production"),
                    meta: { name: "产能填报", isMenu: true, icon: 'icon-cttq-xiangmu', code: "budget:product:number" },
                    children: [
                        {
                            path: '/production/productionFill/fill',
                            component: () => import( /* webpackChunkName: "productionFill" */ "@/views/production/fill.vue"),
                            meta: { name: "产能填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:product:number",eventId: "budget_sccl_fb_button" }
                        }, {
                            path: '/production/productionCheck/check',
                            component: () => import( /* webpackChunkName: "productionCheck" */ "@/views/production/check.vue"),
                            meta: { name: "产能查询", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:product:number",eventId: "budget_sccl_ch_button"  }
                        }]
                },
                {
                    path: '/produceTest/produceTestFill',
                    redirect: '/produceTest/produceTestFill/fill',
                    component: () => import( /* webpackChunkName: "productionFill" */ "@/views/produceTest"),
                    meta: { name: "中试需求", isMenu: true, icon: 'icon-cttq-xiangmu', code: "budget:product:lab" },
                    children: [
                        {
                            path: '/produceTest/produceTestFill/fill',
                            component: () => import( /* webpackChunkName: "productionFill" */ "@/views/produceTest/fill.vue"),
                            meta: { name: "中试需求填报", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:product:lab:budget",eventId: "budget_sczs_fb_button" }
                        }, {
                            path: '/produceTest/produceTestCheck/check',
                            component: () => import( /* webpackChunkName: "productionCheck" */ "@/views/produceTest/check.vue"),
                            meta: { name: "中试需求查询", isMenu: false, icon: 'icon-cttq-xiangmu', code: "budget:product:lab:budget",eventId: "budget_sczs_ch_button" }
                        }]
                },
            ]
        },

        {
            path: '/procurement',
            redirect: '/procurement/materialsFill',
            component: () => import( /* webpackChunkName: "procurement" */ "@/views/procurement"),//采购
            meta: { isActive: 0, name: "采购预算", isMenu: true, icon: 'img/ico_caigou.png', activeIcon: 'img/ico_caigou_s.png', code: "budget:purchase" },
            children: [
                //原材料采购 
                {
                    path: '/procurement/materialsFill',
                    redirect: '/procurement/materialsFill/fill',
                    component: () => import( /* webpackChunkName: "materialsFill" */ "@/views/procurement/materials"),
                    meta: { name: "原材料", isMenu: true, icon: 'icon-cttq-yuancailiaocaigou', code: "budget:purchase:number" },
                    children: [
                        {
                            path: '/procurement/materialsFill/fill',
                            component: () => import( /* webpackChunkName: "materialsFill" */ "@/views/procurement/materials/fill.vue"),
                            meta: { name: "原材料采购填报", isMenu: false, icon: 'icon-cttq-yuancailiaocaigou', code: "budget:purchase:number",eventId: "budget_yclcg_fb_button" }
                        }, {
                            path: '/procurement/materialsCheck/check',
                            component: () => import( /* webpackChunkName: "materialsCheck" */ "@/views/procurement/materials/check.vue"),
                            meta: { name: "原材料采购查询", isMenu: false, icon: 'icon-cttq-yuancailiaocaigou', code: "budget:purchase:number",eventId: "budget_yclcg_ch_button" }
                        }]
                },
                // 原材料单价填报
                {
                    path: '/procurement/materialsPriceFill',
                    redirect: '/procurement/materialsPriceFill/fill',
                    component: () => import( /* webpackChunkName: "materialsPriceFill" */ "@/views/procurement/materialsPrice"),
                    meta: { name: "原材料价格", isMenu: true, icon: 'icon-cttq-yuancailiao', code: "budget:purchase:price" },
                    children: [
                        {
                            path: '/procurement/materialsPriceFill/fill',
                            component: () => import( /* webpackChunkName: "materialsPriceFill" */ "@/views/procurement/materialsPrice/fill.vue"),
                            meta: { name: "原材料价格填报", isMenu: false, icon: 'icon-cttq-yuancailiao', code: "budget:purchase:price",eventId: "budget_ycljg_fb_button" }
                        }, {
                            path: '/procurement/materialsPriceCheck/check',
                            component: () => import( /* webpackChunkName: "materialsPriceFill" */ "@/views/procurement/materialsPrice/check.vue"),
                            meta: { name: "原材料价格查询", isMenu: false, icon: 'icon-cttq-yuancailiao', code: "budget:purchase:price",eventId: "budget_ycljg_ch_button" }
                        }]
                },
                 // 代理发货采购成本预算
                 {
                    path: '/procurement/costBudget',
                    redirect: '/procurement/costBudget/fill',
                    component: () => import("@/views/procurement/costBudget"),
                    meta: { name: "代理发货采购成本预算", isMenu: true, icon: 'icon-cttq-yuancailiao', code: "budget:purchase:dlfhprice" },
                    children: [
                        {
                            path: '/procurement/costBudget/fill',
                            component: () => import("@/views/procurement/costBudget/fill.vue"),
                            meta: { name: "代理发货采购成本预算填报", isMenu: false, icon: 'icon-cttq-yuancailiao', code: "budget:purchase:dlfhprice",eventId: "budget_ycljg_fb_button" }
                        }, {
                            path: '/procurement/costBudget/check',
                            component: () => import("@/views/procurement/costBudget/check.vue"),
                            meta: { name: "代理发货采购成本预算查询", isMenu: false, icon: 'icon-cttq-yuancailiao', code: "budget:purchase:dlfhprice:budget",eventId: "budget_ycljg_ch_button" }
                        }]
                }
            ]
        },
        {
            path: '/personnel',
            redirect: '/personnel/penlManFill',
            component: () => import( /* webpackChunkName: "personnel" */ "@/views/personnel"),//人事
            meta: { isActive: 0, name: "薪酬预算", isMenu: true, icon: 'img/ico_xinchou.png', activeIcon: 'img/ico_xinchou_s.png', code: "budget:hr" },
            children: [
                {
                    path: '/personnel/penlManFill',
                    redirect: '/personnel/penlManFill/fill',
                    component: () => import( /* webpackChunkName: "penlManFill" */ "@/views/personnel/manager"),
                    meta: { name: "薪酬", isMenu: true, icon: 'icon-cttq-xinchou', code: "budget:hr:pay" },
                    children: [
                        {
                            path: '/personnel/penlManFill/fill',
                            component: () => import( /* webpackChunkName: "penlManFill" */ "@/views/personnel/manager/fill.vue"),
                            meta: { name: "薪酬填报", isMenu: false, icon: 'icon-cttq-xinchou', code: "budget:hr:pay",eventId: "budget_rsxc_fb_button" },
                        },
                        {
                            path: '/personnel/penlManCheck/check',
                            // component: () => import( /* webpackChunkName: "penlManCheck" */ "@/views/personnel/manager/check.vue"),
                            component: () => import( /* webpackChunkName: "penlManCheck" */ "@/views/personnel/manager/check.vue"),
                            meta: { name: "薪酬查询", isMenu: false, icon: 'icon-cttq-xinchou', code: "budget:hr:pay",eventId: "budget_rsxc_ch_button" }

                        },
                        {
                            path: '/personnel/penlManFill/salaryRule',
                            // component: () => import( /* webpackChunkName: "salaryRule" */ "@/views/personnel/manager/salaryRule.vue"),
                            component: () => import( /* webpackChunkName: "salaryRule" */ "@/views/personnel/manager/salaryRule.vue"),
                            meta: { name: "薪酬规则", isMenu: false, icon: 'icon-cttq-xinchou', code: "budget:hr:pay" }
                        },
                        {
                            // v2.0新加发布后的详情完成页面
                            path: '/personnel/penlManFill/salaryRuleFinish',
                            component: () => import( /* webpackChunkName: "salaryRule" */ "@/views/personnel/manager/salaryRuleFinish.vue"),
                            meta: { name: "部门薪酬福利", isMenu: false, icon: 'icon-cttq-xinchou', code: "budget:hr:pay" }
                        },
                    ]

                },
                {
                    path: '/personnel/bonus',
                    redirect: '/personnel/bonus/penlBossFill',
                    component: () => import( /* webpackChunkName: "bonus" */ "@/views/personnel/bonus"),
                    meta: { name: "奖金", isMenu: true, icon: 'icon-cttq-jiangjin', activeIcon: 'img/ico_renshi_s.png', code: "budget:hr:bonus" },
                    children: [
                        {
                            path: '/personnel/bonus/penlBossFill',
                            component: () => import( /* webpackChunkName: "penlBossFill" */ "@/views/personnel/bonus/boss/fill.vue"),
                            meta: { name: "高管奖金填写", isMenu: false, icon: 'icon-cttq-jiangjin', code: "budget:hr:bonus:manage" }
                        },
                        {
                            path: '/personnel/bonus/penlBossCheck',
                            component: () => import( /* webpackChunkName: "penlBossCheck" */ "@/views/personnel/bonus/boss/check.vue"),
                            meta: { name: "高管奖金查看", isMenu: false, icon: 'icon-cttq-jiangjin', code: "budget:hr:bonus:manage" }
                        },
                        {
                            path: '/personnel/bonus/penlResearchBonusFill',
                            component: () => import( /* webpackChunkName: "penlResearchBonusFill" */ "@/views/personnel/bonus/researchBonus/fill.vue"),
                            meta: { name: "研究院奖金填写", isMenu: false, icon: 'icon-cttq-jiangjin', code: "budget:hr:bonus:research", eventId: "budget_yjyjj_fb_button" }
                        },
                        {
                            path: '/personnel/bonus/penlResearchBonusCheck',
                            component: () => import( /* webpackChunkName: "penlResearchBonusCheck" */ "@/views/personnel/bonus/researchBonus/check.vue"),
                            meta: { name: "研究院奖金查看", isMenu: false, icon: 'icon-cttq-jiangjin', code: "budget:hr:bonus:research", eventId: "budget_yjyjj_ch_button"}
                        },
                        {
                            path: '/personnel/bonus/penlSaleBonusFill',
                            component: () => import( /* webpackChunkName: "penlSaleBonusFill" */ "@/views/personnel/bonus/saleBonus/fill.vue"),
                            meta: { name: "销售奖金填写", isMenu: false, icon: 'icon-cttq-jiangjin', code: "budget:hr:bonus:sale", eventId: "budget_rsxsjj_fb_button" }
                        },
                        {
                            path: '/personnel/bonus/penlSaleBonusCheck',
                            component: () => import( /* webpackChunkName: "penlSaleBonusCheck" */ "@/views/personnel/bonus/saleBonus/check.vue"),
                            meta: { name: "销售奖金查看", isMenu: false, icon: 'icon-cttq-jiangjin', code: "budget:hr:bonus:sale", eventId: "budget_rsxsjj_ch_button" }
                        }
                    ]
                },
                {
                    path: '/personnel/putUnderFee',
                    redirect: '/personnel/putUnderFee/fill',
                    component: () => import( /* webpackChunkName: "putUnderFee" */ "@/views/personnel/putUnderFee"),
                    meta: { name: "归口福利费", isMenu: true, icon: 'icon-cttq-xinchou', code: "budget:hr:welfareexpenses" },
                    children: [
                        {
                            path: '/personnel/putUnderFee/fill',
                            component: () => import( /* webpackChunkName: "putUnderFee" */ "@/views/personnel/putUnderFee/fill.vue"),
                            meta: { name: "归口福利费填报", isMenu: false, icon: 'icon-cttq-xinchou', code: "budget:hr:welfareexpenses:budget" },
                        },
                        {
                            path: '/personnel/putUnderFee/check',
                            component: () => import( /* webpackChunkName: "putUnderFee" */ "@/views/personnel/putUnderFee/check.vue"),
                            meta: { name: "归口福利费查看", isMenu: false, icon: 'icon-cttq-xinchou', code: "budget:hr:welfareexpenses:budget" }

                        }
                    ]

                },
            ]
        },
        {
            path: '/finance',
            redirect: '/finance/materialsFill',
            component: () => import( /* webpackChunkName: "finance" */ "@/views/procurement"),
            meta: { isActive: 0, name: "财务预算", isMenu: true, icon: 'img/ico_caiwu.png', activeIcon: 'img/ico_caiwu_s.png', code: "budget:finance" },
            children: [
                {
                    path: '/funds/fundsFill',
                    redirect: '/funds/fundsFill/fill',
                    component: () => import( /* webpackChunkName: "fundsFill" */ "@/views/funds"),
                    meta: { name: "资金", isMenu: true, icon: 'icon-cttq-zijin', code: "budget:finance:capital" },
                    children: [{
                        path: '/funds/fundsFill/fill',
                        component: () => import( /* webpackChunkName: "fundsFill" */ "@/views/funds/fill.vue"),
                        meta: { name: "资金填报", isMenu: false, icon: 'icon-cttq-zijin', code: "budget:finance:capital", eventId: "budget_cwzj_fb_button" }
                    }, {
                        path: '/funds/fundsCheck/check',
                        component: () => import( /* webpackChunkName: "fundsCheck" */ "@/views/funds/check.vue"),
                        meta: { name: "资金查询", isMenu: false, icon: 'icon-cttq-zijin', code: "budget:finance:capital", eventId: "budget_cwzj_ch_button" }
                    }]
                },
                {
                    path: '/finance/taxesFill',
                    redirect: '/finance/taxesFill/fill',
                    component: () => import( /* webpackChunkName: "taxesFill" */ "@/views/taxes"),
                    meta: { name: "税金填报", isMenu: true, icon: 'icon-cttq-shuijin', code: "budget:finance:taxes" },
                    children: [{
                        path: '/finance/taxesFill/fill',
                        component: () => import( /* webpackChunkName: "taxesFill" */ "@/views/taxes/fill.vue"),
                        meta: { name: "税金填报", isMenu: false, icon: 'icon-cttq-shuijin', code: "budget:finance:taxes", eventId: "budget_cwsj_fb_button" }
                    }, {
                        path: '/finance/taxesCheck/check',
                        component: () => import( /* webpackChunkName: "taxesCheck" */ "@/views/taxes/check.vue"),
                        meta: { name: "税金查看", isMenu: false, icon: 'icon-cttq-shuijin', code: "budget:finance:taxes", eventId: "budget_cwsj_ch_button" }
                    }]
                }
            ]
        },
        {
            path: '/generalProject',
            component: () => import( /* webpackChunkName: "generalProject" */ "@/views/generalProject"),
            meta: { isActive: 0, name: "部门预算", isMenu: true, icon: 'img/ico_bumen.png', activeIcon: 'img/ico_bumen_s.png', code: 'budget:part' },
            children: [

                {
                    path: '/generalProject/costFill',
                    redirect: '/generalProject/costFill/fill',
                    component: () => import( /* webpackChunkName: "costFill" */ "@/views/cost"),
                    meta: { name: "费用填报", isMenu: true, icon: 'icon-cttq-feiyong', code: "budget:part:cost" },
                    children: [
                        {
                            path: '/generalProject/costFill/fill',
                            component: () => import( /* webpackChunkName: "costFill" */ "@/views/cost/fill.vue"),
                            meta: { name: "费用填报", isMenu: false, icon: 'icon-cttq-feiyong', code: "budget:part:cost:budget", eventId:"budget_bmys_fb_button" },
                        },
                        {
                            path: '/generalProject/costCheck/check',
                            component: () => import( /* webpackChunkName: "costCheck" */ "@/views/cost/check.vue"),
                            meta: { name: "费用查询", isMenu: false, icon: 'icon-cttq-feiyong', code: "budget:part:cost:budget", eventId:"budget_bmys_ch_button" }
                        }]
                }, {
                    path: '/generalProject/personFill',
                    redirect: '/generalProject/costFill/fill',
                    component: () => import( /* webpackChunkName: "personFill" */ "@/views/person"),
                    meta: { name: "人员填报", isMenu: true, icon: 'icon-cttq-renyuan', code: "budget:else:personnel" },
                    children: [
                        {
                            path: '/generalProject/personFill/fill',
                            component: () => import( /* webpackChunkName: "personFill" */ "@/views/person/fill.vue"),
                            meta: { name: "人员填报", isMenu: false, icon: 'icon-cttq-renyuan', code: "budget:else:personnel", eventId:"budget_rytz_fb_button" }
                        }, {
                            path: '/generalProject/personCheck/check',
                            component: () => import( /* webpackChunkName: "personCheck" */ "@/views/person/check.vue"),
                            meta: { name: "人员查询", isMenu: false, icon: 'icon-cttq-renyuan', code: "budget:else:personnel", eventId:"budget_rytz_ch_button" }
                        }]
                }, {
                    path: '/generalProject/deviceFill',
                    redirect: '/generalProject/deviceFill/fill',
                    component: () => import( /* webpackChunkName: "deviceFill" */ "@/views/device"),
                    meta: { name: "设备填报", isMenu: true, icon: 'icon-cttq-shebei', code: "budget:else:equipment" },
                    children: [
                        {
                            path: '/generalProject/deviceFill/fill',
                            component: () => import( /* webpackChunkName: "deviceFill" */ "@/views/device/fill.vue"),
                            meta: { name: "设备填报", isMenu: false, icon: 'icon-cttq-shebei', code: "budget:else:equipment" }
                        }, {
                            path: '/generalProject/deviceCheck/check',
                            component: () => import( /* webpackChunkName: "deviceCheck" */ "@/views/device/check.vue"),
                            meta: { name: "设备查询", isMenu: false, icon: 'icon-cttq-shebei', code: "budget:else:equipment" }
                        }]
                }
                // ,{
                //     path: '/generalProject/funDeviceFill',
                //     redirect: '/personnel/funDeviceFill/fill',
                //     component: () => import( /* webpackChunkName: "funDeviceFill" */ "@/views/device"),
                //     meta: { name: "归口设备填报", isMenu: true, icon: 'icon-cttq-shebei', code: "budget:else:sumequipment"},
                //     children:[
                //         {
                // 			path: '/personnel/funDeviceFill/fill',
                //             component: () => import( /* webpackChunkName: "funDeviceFill" */ "@/views/funDevice/fill.vue"),
                // 			meta: { name: "归口设备填报", isMenu: false, icon: 'icon-cttq-shebei', code: "budget:else:sumequipment"}
                // 		}, {
                // 			path: '/personnel/funDeviceCheck/check',
                //             component: () => import( /* webpackChunkName: "funDeviceCheck" */ "@/views/funDevice/check.vue"),
                // 			meta: {name: "归口设备查询",isMenu: false,icon: 'icon-cttq-shebei',code: "budget:else:sumequipment"}
                // 		}]
                // }
            ]
        }, {
            path: '/generalProject/funDeviceFill',
            component: () => import( /* webpackChunkName: "managementPlatform" */ "@/views/managementPlatform"),
            meta: { isActive: 0, name: "审核及反馈", isMenu: true, icon: 'img/ico_shjfk.png', activeIcon: 'img/ico_shjfk_s.png', code: 'budget:manage' },
            children: [
                {
                    path: '/managementPlatform',
                    component: () => import( /* webpackChunkName: "tables" */ "@/views/managementPlatform/fill.vue"),
                    meta: { isActive: 0, name: "财务反馈", isMenu: true, icon: 'img/ico_baobiao.png', activeIcon: 'img/ico_baobiao_s.png', code: 'budget:manage:manage' }
                },
                {
                    path: '/generalProject/funDeviceFill',
                    redirect: '/personnel/funDeviceFill/fill',
                    component: () => import( /* webpackChunkName: "funDeviceFill" */ "@/views/device"),
                    meta: { name: "归口审核", isMenu: true, icon: 'icon-cttq-shebei', code: "budget:manage:sumequipment" },
                    children: [
                        {
                            path: '/personnel/funDeviceFill/fill',
                            component: () => import( /* webpackChunkName: "funDeviceFill" */ "@/views/funDevice/fill.vue"),
                            meta: { name: "归口设备填报", isMenu: false, icon: 'icon-cttq-shebei', code: "budget:manage:sumequipment:budget",eventId: "budget_gksh_fb_button" }
                        }, {
                            path: '/personnel/funDeviceCheck/check',
                            component: () => import( /* webpackChunkName: "funDeviceCheck" */ "@/views/funDevice/check.vue"),
                            meta: { name: "归口设备查询", isMenu: false, icon: 'icon-cttq-shebei', code: "budget:manage:sumequipment:budget",eventId: "budget_gksh_ch_button" }
                        }]
                },
            ]
        },
        {
            path: '/tables',
            component: () => import( /* webpackChunkName: "tables" */ "@/views/tables/fill.vue"),
            meta: { isActive: 0, name: "报表", isMenu: true, icon: 'img/ico_baobiao.png', activeIcon: 'img/ico_baobiao_s.png', code: 'budget:reportform' },
            children: [
                {
                    path: '/historyReport',
                    component: () => import( /* webpackChunkName: "tables" */ "@/views/tables/fill.vue"),
                    meta: { isActive: 0, name: "历史报表", isMenu: true, icon: 'icon-cttq-xiangmu', activeIcon: 'img/ico_baobiao_s.png', code: 'budget:historyreportform:page' }
                },
                {
                    path: '/importReport',
                    component: () => import( /* webpackChunkName: "tables" */ "@/views/tables/fill.vue"),
                    meta: { isActive: 0, name: "导入报表", isMenu: true, icon: 'icon-cttq-xiangmu', activeIcon: 'img/ico_baobiao_s.png', code: 'budget:rImportreportform:page' }
                },
                {
                    path: '/businessReport',
                    component: () => import( /* webpackChunkName: "tables" */ "@/views/tables/fill.vue"),
                    meta: { isActive: 0, name: "业务查询报表", isMenu: true, icon: 'icon-cttq-xiangmu', activeIcon: 'img/ico_baobiao_s.png', code: 'budget:Businessqueryreportform:page' }
                },
                {
                    path: '/managementReport',
                    component: () => import( /* webpackChunkName: "tables" */ "@/views/tables/fill.vue"),
                    meta: { isActive: 0, name: "管理报表", isMenu: true, icon: 'icon-cttq-xiangmu', activeIcon: 'img/ico_baobiao_s.png', code: 'budget:Administrationreportform:page' }
                },
                {
                    path: '/financeReport',
                    component: () => import( /* webpackChunkName: "tables" */ "@/views/tables/fill.vue"),
                    meta: { isActive: 0, name: "财务报表", isMenu: true, icon: 'icon-cttq-xiangmu', activeIcon: 'img/ico_baobiao_s.png', code: 'budge：Financereportform:page' }
                },
            ]
        }, 
        {//通用 所以放在最后
            path: '/addDevice',
            component: () => import( /* webpackChunkName: "addDevice" */ "@/views/device/addDevice.vue"),
            meta: { name: "工程-设备--新增", isMenu: false, code: 'addDevice' }
        },
        {
            path: '/homePage',
            component: () => import( /* webpackChunkName: "homePage" */ "@/views/homePage/homePage.vue"),
            meta: { name: "首页", isMenu: false, code: 'homePage' }
        },],

}];

export default routes;
